<template lang="pug">
.post-title__wrapper(
  :class="{'--tall': isTall, '--subtitled': showSubtitle}"
)
  h2.post-title(
    :title="titleAttr"
    @click.stop=""
    ref="title"
  )
    router-link.--base-color.--underline-effect(
      v-if="link"
      :to="{ name: 'postById', params: { id: post.id }}"
      @focus.native="$emit('focus', $event)"
      @blur.native="$emit('blur', $event)"
    )
      | {{ post.title }}
    template(
      v-else
    ) 
      | {{ post.title }}

  h3.post-subtitle(
    v-if="showSubtitle"
  )
    | {{ post.subtitle }}
</template>

<script>
import IsMountedMixin from '@/mixins/isMounted'

export default {
  name: 'post-title',
  mixins: [IsMountedMixin],
  props: {
    post: {
      type: Object,
      required: true,
    },
    link: {
      type: Boolean,
      default: false,
    },
    subtitle: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      isTall: false,
    }
  },
  computed: {
    titleAttr() {
      return this.link ? this.post.title : undefined
    },
    showSubtitle() {
      return !!this.post.subtitle && this.subtitle
    },
  },
  mounted() {
    new ResizeObserver(this.checkIfTall).observe(this.$root.$el)
    this.checkIfTall()
  },
  methods: {
    async checkIfTall() {
      this.isTall = false
      await this.$nextTick()
      const el = this.$refs.title
      if (!el) return
      this.isTall = el.scrollHeight > el.offsetHeight
    },
  },
}
</script>

<style lang="sass">
/* see App.vue for these root styles:
  --post-title-max-lines: 2
  --post-title-font-size: 3rem
  --post-title-line-height: 1.4 */

.post-title__wrapper  
  &.--tall,
  &.--subtitled
    --post-title-font-size: 2rem

.post-title__wrapper
  display: flex
  flex-direction: column
  justify-content: center
  overflow: hidden
  font-size: var(--post-title-font-size)
  line-height: var(--post-title-line-height)

  &:not(.--subtitled)
    margin-bottom: 1rem

  &:not(.--tall):not(.--subtitled),
  &:not(.--tall) .post-title
    max-height: calc(var(--post-title-line-height) * var(--post-title-max-lines) * 1em)

.post-title,
.post-subtitle
  margin: 0

.post-title
  position: relative
  display: inline-block
  font-size: var(--post-title-font-size)
  line-height: var(--post-title-line-height)
  font-weight: 600

.post-subtitle
  position: relative
  display: inline-block
  font-size: var(--post-subtitle-font-size)
  line-height: var(--post-title-line-height)
  font-weight: 300
  margin-bottom: 1rem

.post-title + .post-subtitle
  margin-top: .5rem

/* Post Card Context: */

// variables
.post-card
  --post-title-min-lines: 1
  --post-title-max-lines: 3

  &.--article
    .post-title__wrapper:not(.--tall)
      --post-title-min-lines: 1
      --post-title-max-lines: 1

  &.--article:not(.--hasImage)
    .post-title__wrapper
      --post-title-min-lines: 2
      --post-title-max-lines: 3

.post-card
  .post-title__wrapper,
  .post-title__wrapper.--tall
    min-height: calc(var(--post-title-line-height) * var(--post-title-min-lines) * 1em)
    max-height: calc(var(--post-title-line-height) * var(--post-title-max-lines) * 1em)
  .post-title
    max-height: calc(var(--post-title-line-height) * var(--post-title-max-lines) * 1em)

  .post-title
    .--underline-effect
      background-image: linear-gradient(var(--accent-color), var(--accent-color))
      background-size: 0% var(--post-card-accent-border-width)

  &:hover,
  &:focus,
  &.--focus
    .post-title
      .--underline-effect
        background-size: 100% var(--post-card-accent-border-width)

  &.--article:not(.--hasImage)
    .post-title__wrapper
      justify-content: flex-end

  &.--media
    .post-title__wrapper
      max-height: calc(100% - 2em)

    .post-title 
      > span,
      > a
        background-color: hsla(var(--accent-color-h),var(--accent-color-s),var(--accent-color-l), .65)
        
      .--underline-effect
        background-image: linear-gradient(white, white)
</style>
